import Vuex from 'vuex'
import Vue from 'vue'
const state = {
  //   server_url: 'http://192.168.200.83:5001', // 测试服务器
  server_url: 'https://www.mnkygs.com',
  // oss_domain: 'http://img-shopping-test.xhty.site/', // 七牛云测试服务器
  is_login: false
}

Vue.use(Vuex)
const mutations = {
  mullogin () {
    state.is_login = true
  },
  mullogout () {
    state.is_login = false
  }
}

// this.$store.dispatch('actLogin')
const actions = {
  actlogin ({ commit }) {
    // 同步调用
    commit('mullogin')
  },
  asyncLogin ({ commit }) {
    // 异步调用
    setTimeout(() => {
      commit('mullogin')
    }, 2000)
  }
}

// $store.getters.isLogin
const getters = {
  isLogin () {
    return state.is_login ? '登录' : '未登录'
  }
}

const store = new Vuex.Store({
  state,
  mutations,
  actions,
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/vuex/store.js